import { Colors, Flex, IconChevronRight, Typography } from '@banhala/ui-kit';
import { TouchableOpacity } from 'react-native';

type Props = {
  title: string;
  description?: string;
  showRightArrow?: boolean;
  onPress: () => void;
};

export const SettingRow = ({
  title,
  description,
  showRightArrow = true,
  onPress,
}: Props) => {
  return (
    <TouchableOpacity onPress={onPress} activeOpacity={0.6}>
      <Flex.Row
        alignItems="center"
        padding={{ vertical: 16, horizontal: 16 }}
      >
        <Flex flex={1} padding={{ right: 8 }}>
          <Typography type="body1" color="content_primary">
            {title}
          </Typography>
        </Flex>
        {description != null && (
          <Flex padding={{ right: 4 }}>
            <Typography type="body1" color="content_secondary">
              {description.length > 0 ? description : '선택하기'}
            </Typography>
          </Flex>
        )}
        {showRightArrow && (
          <IconChevronRight size={20} fill={Colors.content_tertiary} />
        )}
      </Flex.Row>
    </TouchableOpacity>
  );
};
